import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  shopSubCategories: null,
  loading: false,
  shopBtnLoading: false,
  deleteBtnLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOP_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
